<template>
    <div class="attachment-edit">
        <div class="container">
            <IconDocument class="icon" />

            <div class="forms">
                <input v-model.trim="model.name"
                       :class="{ error: v.model.name.$error }"
                       class="input name"
                       type="text" />

                <Combobox v-model="model.type"
                          :class="{ error: v.model.type.$error }"
                          :options="typeDict"
                          :to-title="(it) => it.name"
                          class="dropdown type" />
            </div>

            <div class="actions">
                <button :disabled="v.$invalid" class="action save only-icon primary" @click="save">
                    <IconCheck class="icon" />
                </button>
                <button class="action no-border close only-icon" @click="close">
                    <IconTrashLarge v-if="newFile" class="icon" />
                    <IconClose v-else class="icon" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Document from '@/common/page_comp/Documents/document.js';
import { DOCUMENT_STATE_NORMAL } from '@/common/page_comp/Documents/document.states.js';
import { getFileName } from '@/common/page_comp/Documents/fileApi.js';
import { requiredRule } from '@/common/util/validations/main.js';
import { nameRulesDefault } from '@/common/util/validations/name.js';
import { getFileType } from '@dsee/util/fileApi.js';
import { useVuelidate } from '@vuelidate/core';
import IconDocument from './icons/document.svg?component';
import IconCheck from './icons/check.svg?component';


function emptyModel() {
    return {
        name: '',
        type: null,
    };
}

export default {
    name: 'AttachmentEdit',
    components: {
        IconDocument,
        IconCheck,
    },
    setup() {
        return {
            v: useVuelidate({
                $autoDirty: true,
                $registerAs: 'editing',
            }),
        };
    },
    props: {
        value: {
            type: Document,
            required: true,
        },
    },
    data() {
        return {
            model: emptyModel(),
        };
    },
    computed: {
        newFile() {
            return !this.value.id;
        },
    },
    inject: {
        typeDict: {
            from: 'documentTypeDict',
            type: Array,
            default: () => [],
        },
    },
    validations() {
        return {
            model: {
                name: {
                    ...nameRulesDefault(),
                },
                type: {
                    ...requiredRule(),
                },
            },
        };
    },
    created() {
        this.reset();
        this.model = Object.assign(emptyModel(), {
            ...this.value.value,
            name: getFileName(this.value.value.name) ?? '',
        });
    },
    methods: {
        reset() {
            this.model = emptyModel();
        },
        save() {
            if (this.v.$invalid)
                return;

            const data = this.value;
            data.value = Object.assign(this.value.value, {
                ...this.model,
                name: `${ this.model.name }.${ getFileType(this.value.value.name) }`,
            });
            data.edited = true;

            this.$emit('save');
        },
        close() {
            if (this.newFile) {
                this.$emit('remove');
                return;
            }

            const data = this.value;
            data.state = DOCUMENT_STATE_NORMAL;
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.attachment-edit {
    width: 100%;

    .container {
        display: flex;
        align-items: center;
        gap: 12px;

        .icon {
            flex: none;
            opacity: .7;
        }

        .forms {
            display: inline-flex;
            flex: 1;
            gap: 12px;

            > * {
                flex: 1;
            }

            .input {
                height: 24px;
                font-size: 12px;
                line-height: 16px;
            }

            .dropdown {
                font-size: 12px;
                line-height: 16px;

                :deep(.selected) {
                    --input-min-height: 24px;
                    height: 24px;
                    padding: 4px 8px;

                    input {
                        font-size: 12px;
                        line-height: 16px;
                    }

                }
            }
        }

        .actions {
            display: inline-flex;
            gap: 12px;

            .save {
                width: 24px;
                height: 24px;
                padding: 4px;
            }

        }
    }
}
</style>
